import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { api } from '../services/api'

interface ConfigDto {
  platformName: string
  logo: string
  primaryColor: string
  secondaryColor: string
  footerEmail?: string
  footerWebsite?: string
  footerAddress?: string
  footerPhone?: string
}

type State = {
  config?: ConfigDto
}

type Actions = {
  setConfig: (config?: ConfigDto) => void
  logout: () => void
}

export const useConfigStore = create(
  persist<State & Actions>(
    (set) => ({
      config: undefined,
      setConfig: (config?: ConfigDto) => {
        return set(() => ({
          config,
        }))
      },
      logout: () => {
        delete api.defaults.headers.Authorization
        return set(() => ({
          config: undefined,
        }))
      },
    }),
    {
      name: 'config',
    },
  ),
)
